/** Public contact details for skutopia.academy (marketing site, privacy, footer). */

export const SITE_NAME = "Skutopia Academy";

export const CONTACT_EMAIL = "team@skutopia.academy";

export const CONTACT_PHONE = "+260 974 274 991";
export const CONTACT_PHONE_TEL = "+260974274991";

export const CONTACT_ADDRESS = {
  line1: "Mai Chola",
  locality: "Lusaka",
  country: "Zambia",
} as const;

/** Single-line mailing address for legal copy and schema.org. */
export const CONTACT_ADDRESS_LINE = `${CONTACT_ADDRESS.line1}, ${CONTACT_ADDRESS.locality}, ${CONTACT_ADDRESS.country}`;

/** Multi-line block for display components. */
export const CONTACT_ADDRESS_LINES = [
  CONTACT_ADDRESS.line1,
  `${CONTACT_ADDRESS.locality}, ${CONTACT_ADDRESS.country}`,
] as const;

export const CONTACT_SOCIAL = {
  facebook: "https://www.facebook.com/SkutopiaAcademy",
  instagram: "https://www.instagram.com/skutopiaacademy",
  youtube: "https://www.youtube.com/@SkutopiaAcademy",
} as const;
